module.exports = __webpack_public_path__ + "static/bnr_square@2x-9fbaf434cce737a875cd645e384a299e.png";